var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-card',{attrs:{"title":_vm.$t('reply.form.edit-template'),"show-back":"","route-url":{name:'owner:reply-templates'}}}),_c('process-reply',{attrs:{"edit":true,"is-template":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }